import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { ConnectivityStatusEnum } from '../enums';

export class ConnectivityState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public isWifiConnected: ConnectivityStatusEnum;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.isWifiConnected = ConnectivityStatusEnum.Uninitialized;
  }
}
